import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const WhyUs = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-gradient-to-br from-indigo-700 via-violet-800 to-purple-900 text-white py-20 md:py-28 overflow-hidden relative">
      <div className="absolute -top-24 -left-24 w-96 h-96 bg-fuchsia-500/20 rounded-full blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Why It Wins */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 backdrop-blur">
            <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-amber-400">
              {t.why.wins.label}
            </span>
            <h3 className="text-2xl md:text-3xl font-bold mb-4 leading-tight">
              {t.why.wins.title}
            </h3>
            <p className="text-lg font-semibold text-indigo-100 mb-4">
              {t.why.wins.lead}
            </p>
            <p className="text-indigo-200 leading-relaxed mb-6">
              {t.why.wins.description}
            </p>
            <p className="text-lg font-bold text-white border-l-4 border-amber-400 pl-4">
              {t.why.wins.highlight}
            </p>
          </div>

          {/* Why Now */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 backdrop-blur">
            <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-amber-400">
              {t.why.now.label}
            </span>
            <h3 className="text-2xl md:text-3xl font-bold mb-4 leading-tight">
              {t.why.now.title}
            </h3>
            <p className="text-indigo-200 leading-relaxed mb-6">
              {t.why.now.description}
            </p>
            <p className="text-lg font-bold text-white border-l-4 border-amber-400 pl-4">
              {t.why.now.highlight}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
